<template lang="pug">
  el-row
    div.sicarf-galeria
      h1.titulo-sicarf Galeria
      img.redimensiona(src="~@/assets/images/linha.png")
    el-row(type="flex" :gutter="5")
      el-col(style="padding-bottom: 4px;" :xs="24" :sm="8")
        img.image(:src="images[12]" :key="12" @click="index = 12" loading="lazy")
      el-col.hidden-xs-only(:xs="24" :sm="8")
        div
          img.image(:src="images[0]" :key="0" @click="index = 0" loading="lazy")
          img.image(:src="images[3]" :key="3" @click="index = 3" loading="lazy")
      el-col(style="padding-bottom: 4px;" :xs="24" :sm="8")
        img.image(:src="images[10]" :key="10" @click="index = 10" loading="lazy")
    vue-gallery-slideshow(:images="images" :index="index" @close="index = null")
</template>

<script>
import VueGallerySlideshow from 'vue-gallery-slideshow'
import IMG_0418 from '@/assets/images/fotosGaleriaSicarf/IMG_0418.jpg'
import IMG_0430 from '@/assets/images/fotosGaleriaSicarf/IMG_0430.jpg'
import IMG_0432 from '@/assets/images/fotosGaleriaSicarf/IMG_0432.jpg'
import IMG_0447 from '@/assets/images/fotosGaleriaSicarf/IMG_0447.jpg'
import IMG_0448 from '@/assets/images/fotosGaleriaSicarf/IMG_0448.jpg'
import IMG_0867 from '@/assets/images/fotosGaleriaSicarf/IMG_0867.jpg'
import IMG_0868 from '@/assets/images/fotosGaleriaSicarf/IMG_0868.jpg'
import IMG_0872 from '@/assets/images/fotosGaleriaSicarf/IMG_0872.jpg'
import IMG_0877 from '@/assets/images/fotosGaleriaSicarf/IMG_0877.jpg'
import IMG_0893 from '@/assets/images/fotosGaleriaSicarf/IMG_0893.jpg'
import IMG_0907 from '@/assets/images/fotosGaleriaSicarf/IMG_0907.jpg'
import IMG_0908 from '@/assets/images/fotosGaleriaSicarf/IMG_0908.jpg'
import IMG_0909 from '@/assets/images/fotosGaleriaSicarf/IMG_0909.jpg'
import IMG_0911 from '@/assets/images/fotosGaleriaSicarf/IMG_0911.jpg'
import IMG_2683 from '@/assets/images/fotosGaleriaSicarf/IMG_2683.jpg'
import IMG_2684 from '@/assets/images/fotosGaleriaSicarf/IMG_2684.jpg'
import IMG_8309 from '@/assets/images/fotosGaleriaSicarf/IMG_8309.jpg'

export default {
  components: {
    VueGallerySlideshow
  },
  data () {
    return {
      product: {
        name: 'My image',
        img: '../staic/images/fotosGaleriaSicarf/1.jpg'
      },
      images: [
        IMG_0418,
        IMG_0430,
        IMG_0432,
        IMG_0447,
        IMG_0448,
        IMG_0867,
        IMG_0868,
        IMG_0872,
        IMG_0877,
        IMG_0893,
        IMG_0907,
        IMG_0908,
        IMG_0909,
        IMG_0911,
        IMG_2683,
        IMG_2684,
        IMG_8309
      ],
      index: null
    }
  }
}
</script>

<style>
  .display-none {
    display: none;
  }
  .vgs__container {
    top: 15%;
  }
  .sicarf-galeria {
    text-align: center;
    padding-bottom: 20px;
  }
  .redimensiona {
    width: 150px;
  }
  .titulo-sicarf {
    text-align: center;
    color: black;
    font-weight: bold;
    font-size: 36px;
    margin-bottom: 2px;
  }
  .image {
    height: 100%;
    width: 100%;
    background-size: cover;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/home/TheGallery.vue